import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
         <Col md={6}>{new Date().getFullYear()} © Compu Vision.</Col> 
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                v 1.0.0.8
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
